<template>
  <div>
    <div class="row partners align-items-end">
      <div class="col text-center">
        <a href="http://www.books-xxi.com.ua/catalog/chorni-vivtsi">
          <img class="partner-vivtcy" aria-hidden="true" src="/public/img/partners/vivtcy.svg"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="https://derevo-kazok.org">
          <img class="partner-derevokazok" aria-hidden="true" src="/public/img/partners/derevo-kazok-188-125.png"/>
        </a>
      </div>
      <div class="col text-center">
        <a
          href="http://teatr-koleso.kiev.ua/%D1%81%D1%82%D1%83%D0%B4%D0%B8%D1%8F-%D0%BA%D0%BE%D0%BB%D0%B5%D1%81%D0%B8%D0%BA%D0%BE">
          <img class="partner-kolesiko" aria-hidden="true" src="/public/img/partners/kolesiko.jpg"/>
        </a>
      </div>
      <div class="col text-center">
        <a
          href="http://teatr-koleso.kiev.ua/">
          <img class="partner-koleso" aria-hidden="true" src="/public/img/partners/koleso.svg"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="http://artbooks-publishing.com/?___store=ua">
          <img class="partner-artbooks" aria-hidden="true" src="/public/img/partners/artbooks.svg"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="http://arabesky.org.ua/">
          <img class="partner-kazkain" aria-hidden="true" src="/public/img/partners/arabesky.svg"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="https://kazka.in/">
          <img class="partner-arabesky" aria-hidden="true" src="/public/img/partners/kazkain.svg"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="https://www.facebook.com/kazkarkablog/">
          <img class="part3ner-kazkarka" aria-hidden="true" src="/public/img/partners/kazkarka.svg"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="https://www.facebook.com/ggagency.ua/">
          <img class="partner-gg" aria-hidden="true" src="/public/img/partners/gg.jpg"/>
        </a>
      </div>
      <div class="col text-center">
        <a
          href="https://www.facebook.com/%D0%92%D0%BE%D0%BA%D0%B0%D0%BB%D1%8C%D0%BD%D0%B0-%D1%81%D1%82%D1%83%D0%B4%D1%96%D1%8F-%D0%9D%D0%9E%D0%A2%D0%90-451578905045568/">
          <img class="partner-nota" aria-hidden="true" src="/public/img/partners/nota.png"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="https://www.facebook.com/DobriKazky/">
          <img class="partner-dobri-kazky" aria-hidden="true" src="/public/img/partners/dobri_kazky.svg"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="http://www.barabooka.com.ua/">
          <img class="partner-barabooka" aria-hidden="true" src="/public/img/partners/barabooka_logo_3.png"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="https://pustunchik.ua/ua">
          <img class="partner-pustunchik" aria-hidden="true" src="/public/img/partners/pustunchik.png"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="https://www.facebook.com/%D0%A1%D1%82%D1%83%D0%B4%D1%96%D1%8F-%D0%9A%D0%BE%D1%84%D0%B5%D1%97%D0%BD-101233683258190/?eid=ARAO2wr5t1WRwwjDN7l7OLcsyZBcMLdTc_l5sNrdOPZEkU7zcgsW52MwsK3_2MGakwNUV3_LMGOvQIEJ&timeline_context_item_type=intro_card_work&timeline_context_item_source=100000689491352&fref=tag">
          <img class="partner-kofein" aria-hidden="true" src="/public/img/partners/kofein.jpg"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="http://www.bratske.org.ua">
          <img class="partner-bratske" aria-hidden="true" src="/public/img/partners/bratske.png"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="http://muzbat.org">
          <img class="partner-muzbat" aria-hidden="true" src="/public/img/partners/muzbat.jpg"/>
        </a>
      </div>
      <div class="col text-center">
        <a href="https://www.facebook.com/babymozartua/">
          <img class="partner-babymozart" aria-hidden="true" src="/public/img/partners/baby_mozart.png"/>
        </a>
      </div>
      <div class="col text-center partners-bestradio">
        <a href="https://bestradio.fm/ukr/" title="Радіо онлайн слухати безкоштовно">
          <img src="https://bestradio.fm/ukr/img/big-button-bestradio-fm.png"
               width="150"
               height="150"
               alt="Радіо онлайн слухати безкоштовно"
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartnersPage'
}
</script>

<style lang="scss" scoped>
  .partner-kazkain {
    width: 200px;
  }

  .partner-vivtcy {
    width: 120px;
  }

  .partner-gg {
    width: 140px;
  }

  .partner-arabesky {
    width: 200px;
  }

  .partner-kazkarka {
    width: 150px;
  }

  .partner-derevokazok {
    width: 130px;
  }

  .partner-kolesiko {
    width: 150px;
  }

  .partner-koleso {
    width: 83px;
  }

  .partner-barabooka {
    width: 240px;
  }

  .partner-artbooks {
    width: 100px;
  }

  .partner-nota {
    width: 130px;
  }

  .partner-dobri-kazky {
    width: 120px;
  }

  .partner-pustunchik {
    width: 200px;
  }

  .partner-muzbat {
    width: 75px;
  }

  .partner-kofein {
    width: 200px;
  }

  .partner-bratske {
    width: 200px;
  }

  .partner-babymozart {
    width: 200px;
  }

  .partners-bestradio > a > img {
    width: 100px;
    height: 100px;
  }

  .partners .col {
    padding-top: 30px;
    min-width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/PartnersPage.vue